<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.adminUsersRole')"
    resource="admin_users_roles"
    :onFetchData="onFetchData"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/admin_users_roles.js';
import { columnsExtend as adminUserColumnsExtend } from '../admin_entities/admin_user_detail.js';

@Component
export default class AdminUsersRoles extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const [email] = adminUserColumnsExtend(['email'])

    const array = [
      type === 'show' && 'id',
      {
        ...email,
        prop: 'admin_user.email',
        minWidth: 140,
      },
      'role',
      'is_block',
      'created_at',
      'updated_at'
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      // 防止chrome自动填充账号密码
      {
        prop: 'email_placeholder',
        label: 'email',
        renderCell: (h) => <input h={h} />
      },
      {
        prop: 'password_placeholder',
        label: 'password',
        renderCell: (h) => <input type='password' h={h} />
      },
      {
        prop: 'admin_user_attributes.email',
        label: this.$t('adminUser.email'),
        renderCell: {
          component: 'input',
          required: true,
          props: {
            disabled: type === 'edit',
          }
        }
      },
      type === 'new' && {
        prop: 'admin_user_attributes.password',
        label: this.$t('adminUser.password'),
        renderCell: {
          component: 'input',
          required: true,
          props: {
            showPassword: true,
          }
        }
      },
      type === 'new' && {
        prop: 'admin_user_attributes.password_confirmation',
        label: this.$t('adminUser.passwordConfirmation'),
        renderCell: {
          component: 'input',
          required: true,
          props: {
            showPassword: true,
          }
        }
      },
      'role_id'
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   */
  actions({ row }, { remove, reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'admin_users_roles.edit', params: { id: row.id } }
        }
      },
      row.is_block && {
        component: 'confirmButton',
        props: {
          label: '解冻',
          can: 'admin_users_roles.update',
          type: 'primary'
        },
        on: {
          confirm: async () =>  {
            await this.$autoLoading(this.$request.put(`/admin_users_roles/${row.id}/is_block_to_false`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      !row.is_block && {
        component: 'confirmButton',
        props: {
          label: '冻结',
          can: 'admin_users_roles.update',
          type: 'primary'
        },
        on: {
          confirm: async () =>  {
            await this.$autoLoading(this.$request.put(`/admin_users_roles/${row.id}/is_block_to_true`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'admin_users_roles.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/admin_users_roles', { params: { ...this.$route.query, role_kind_eq: 'custom' } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/admin_users_roles/${this.$route.params.id}`);
      return { data };
    }

    if (type === 'new') {
      return {}
    }
  }
}

export const route = [
  {
    path: '/admin_users_roles',
    name: 'admin_users_roles.index',
    component: AdminUsersRoles,
    props: {
      type: 'index',
    }
  },
  {
    path: '/admin_users_roles/new',
    name: 'admin_users_roles.new',
    component: AdminUsersRoles,
    props: {
      type: 'new',
    }
  },
  {
    path: '/admin_users_roles/:id',
    name: 'admin_users_roles.show',
    component: AdminUsersRoles,
    props: {
      type: 'show',
    }
  },
  {
    path: '/admin_users_roles/:id/edit',
    name: 'admin_users_roles.edit',
    component: AdminUsersRoles,
    props: {
      type: 'edit'
    }
  }
]
</script>

<style lang="scss" scoped>
  /deep/ .email_placeholder, /deep/ .password_placeholder {
    position: fixed;
    top: -200%;
    left: -200%;
  }
</style>
